import { Button } from '@components/Common';
import OperationLoader from '@components/Common/Loaders/OperationLoader';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { NavLink } from 'react-router';
import styled from 'styled-components';

//#region styled
const CenterWrapper = styled.div`
  text-align: center;
`;

const ModeContainer = styled.div`
  display: inline-block;
  margin-bottom: 15px;
  background: rgb(51, 63, 72);
`;

const ModeLink = styled(NavLink)`
  display: inline-block;
  border: 1px solid #666;
  padding: 10px 35px;
  text-decoration: none;

  border-right-width: 0;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.45);

  &:last-child {
    border-right-width: 1px;
  }

  &.active {
    background: none;
    color: rgba(255, 255, 255, 0.85);
  }

  &:hover {
    color: rgba(255, 255, 255, 0.85);
    background: rgba(255, 255, 255, 0.07);
  }
`;

const UpdateButton = styled(Button)`
  display: inline-block;
  padding: 10px 35px;
  text-decoration: none;

  border-right-width: 0;
  background: rgb(5, 195, 222);
  color: rgba(255, 255, 255);

  margin-left: 20px;
  border-right-width: 1px;
`;

const Loader = styled.div`
  display: inline-block;
  position: absolute;
  margin-top: 12px;
  margin-left: 10px;
`;

//#endregion

interface ComponentProps {
  fetch: () => void;
  isEnabled: boolean;
  isLoading: boolean;
}

type Props = ComponentProps & WithTranslation;

const AdminNavigation: React.FC<Props> = ({ t, isLoading, isEnabled, fetch }) => {
  const {
    usersUrl,
    hydrogenPeroxidesUrl,
    loadingInfosUrl,
    flowMetersUrl,
    deliveryDestinationsUrl,
    transportationCompaniesUrl
  } = {
    usersUrl: '/admin/users',
    hydrogenPeroxidesUrl: '/admin/hydrogenperoxides',
    loadingInfosUrl: '/admin/loadinginfos',
    flowMetersUrl: '/admin/flowmeters',
    deliveryDestinationsUrl: '/admin/deliverydestinations',
    transportationCompaniesUrl: '/admin/transportationcompanies'
  };

  return (
    <CenterWrapper>
      <ModeContainer>
        <ModeLink to={usersUrl}>
          {t('pages.users')}
        </ModeLink>
        <ModeLink to={loadingInfosUrl}>
          {t('pages.admin.loading_info')}
        </ModeLink>
        <ModeLink to={flowMetersUrl}>
          {t('pages.admin.flow_meters')}
        </ModeLink>
        <ModeLink to={hydrogenPeroxidesUrl}>
          {t('pages.admin.hydrogen_peroxide_flow_metering')}
        </ModeLink>
        <ModeLink to={deliveryDestinationsUrl}>
          {t('pages.admin.delivery_destinations')}
        </ModeLink>
        <ModeLink to={transportationCompaniesUrl}>
          {t('pages.admin.transportation_companies')}
        </ModeLink>
      </ModeContainer>
      <UpdateButton
        primary={true}
        disabled={!isEnabled}
        onClick={() => {
          if (isEnabled) {
            fetch();
          }
        }}
      >
        {t('refresh_bookkeepings')}
      </UpdateButton>
      {isLoading && (
        <Loader>
          <OperationLoader title={t('updating') + '...'} />
        </Loader>
      )}
    </CenterWrapper>
  );
};

export default withTranslation()(AdminNavigation) as React.ComponentType<ComponentProps>;
